import { useEffect, useRef, useState } from "react";
import AdminService from "../../../../service/AdminService";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import localeText from "../../../../locale";
import { Image } from "primereact/image";

const PendingOrders = (props) => {
  const [pendingOrders, setPendingOrders] = useState([]);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  const [loading, setLoading] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const toast = useRef(null);

  useEffect(() => {
    const adminService = new AdminService();
    async function getPendingOrders() {
      try {
        const res = await adminService.getPendingOrders(
          localStorage.getItem("__extraconomy_token")
        );

        if (res.result.length) setPendingOrders(res.result.reverse());
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    getPendingOrders();
  }, []);

  const sendConfirmation = async (idorder) => {
    const adminService = new AdminService();
    if (props.admin) {
      const res = await adminService.confirmOrderBankTransfer(
        localStorage.getItem("__extraconomy_token"),
        props.userInfo,
        idorder
      );
      if (res.messageCode === 200000) {
        const temp = pendingOrders.filter((obj) => obj.id !== idorder);
        setPendingOrders(temp);
        toast.current.show({
          severity: "success",
          summary: localeText("confirmed"),
          detail: localeText("paymentConfirmed"),
          life: 6000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
      }
    }
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <div className="flex justify-content-end">
        <InputText
          value={globalFilterValue}
          onChange={onGlobalFilterChange}
          placeholder="ID, Username..."
        />
      </div>
    );
  };

  const handleDownload = (fileUrl) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.download = fileUrl;
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error fetching the file:", error);
      });
  };

  const receiptDownload = (rowData) => {
    let docFormat = rowData.payments[0]?.banktransferReceipt?.slice(-3);
    return (
      <div className="flex align-items-center gap-3">
        {docFormat === "jpg" || docFormat === "peg" || docFormat === "png" ? (
          <Image
            src={rowData.payments[0].banktransferReceipt}
            alt="Receipt"
            height="30px"
            preview
            downloadable
            target="_blank"
          />
        ) : null}

        {rowData.payments[0]?.banktransferReceipt ? (
          <>
            <Button
              icon="pi pi-download"
              rounded
              text
              raised
              severity="secondary"
              aria-label="Favorite"
              onClick={() => handleDownload(rowData.payments[0]?.banktransferReceipt)}
            ></Button>
          </>
        ) : null}
      </div>
    );
  };

  const formatedAmount = (rowData) => {
    return rowData.itens[0].product.currency + " " + parseFloat(rowData.amountTotal).toFixed(2);
  };

  const formatedDate = (rowData) => {
    const date = new Date(rowData.dateTransaction);
    return date.toDateString();
  };

  const actions = (rowData) => {
    return (
      <div className="flex align-items-center">
        {/* <Button severity="secondary" rounded icon="pi pi-info-circle"></Button> */}
        <Button
          onClick={() => sendConfirmation(rowData.id)}
          label={localeText("transferConfirm")}
        ></Button>
      </div>
    );
  };

  return (
    <div className="card">
      <Toast ref={toast} />
      <h3 className="my-3">{localeText("pendingOrders")}</h3>
      <DataTable
        value={pendingOrders}
        paginator
        rows={10}
        dataKey="id"
        filters={filters}
        loading={loading}
        globalFilterFields={["id", "buyer.username"]}
        header={renderHeader}
        emptyMessage={localeText("noPendingOrders")}
      >
        <Column field="id" header="ID" style={{ minWidth: "5rem" }} />
        <Column field="buyer.username" header={localeText("buyer")} style={{ minWidth: "12rem" }} />
        <Column
          field={formatedAmount}
          header={localeText("totalAmount")}
          style={{ minWidth: "12rem" }}
        />
        <Column field={formatedDate} header={localeText("date")} style={{ minWidth: "12rem" }} />
        <Column
          field={receiptDownload}
          header={localeText("receipt")}
          style={{ minWidth: "12rem" }}
        />
        <Column field={actions} style={{ minWidth: "18rem" }} />
      </DataTable>
    </div>
  );
};
export default PendingOrders;
